// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-settings {
  max-width: 1240px;
  padding: 8px 8px 32px;
}

.admin-settings__header {
  margin-bottom: 24px;
}

.admin-settings__eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #c93312;
}

.admin-settings__title {
  margin: 0 0 8px;
  color: #111 !important;
  font-size: 1.75rem !important;
  font-weight: 700;
  line-height: 1.2;
}

.admin-settings__subtitle {
  margin: 0;
  max-width: 640px;
  color: #5b5b5b;
  font-size: 15px;
  line-height: 1.5;
}

.admin-settings__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 20px;
  align-items: start;
}

.admin-settings__card {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(17, 17, 17, 0.06);
  overflow: hidden;
}

.admin-settings__card-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid #f1f1f1;
  background: linear-gradient(180deg, #fdf9ee 0%, #ffffff 100%);
}

.admin-settings__icon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff;
  color: #c93312;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.admin-settings__card-head h2 {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #111;
}

.admin-settings__card-head p {
  margin: 0;
  color: #6b6b6b;
  font-size: 13px;
  line-height: 1.45;
}

.admin-settings__card-body {
  padding: 20px 22px 22px;
}

.admin-settings__label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #222;
}

.admin-settings__price-field {
  display: flex;
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  background: #fff;
}

.admin-settings__price-field:focus-within {
  border-color: #c93312;
  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.12);
}

.admin-settings__currency {
  display: flex;
  align-items: center;
  padding: 0 14px;
  background: #f7f7f7;
  color: #444;
  font-weight: 700;
  border-right: 1px solid #ececec;
}

.admin-settings__price-field input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  padding: 12px 14px;
  font-size: 16px;
  background: transparent;
}

.admin-settings__hint {
  margin: 8px 0 0;
  color: #7a7a7a;
  font-size: 12px;
  line-height: 1.45;
}

.admin-settings__summary {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.admin-settings__stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
}

.admin-settings__stat span {
  color: #666;
  font-size: 13px;
}

.admin-settings__stat strong {
  color: #111;
  font-size: 14px;
}

.admin-settings__badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: #eef7ee;
  color: #1f7a32;
}

.admin-settings__badge--muted {
  background: #f3f3f3;
  color: #555;
}

.admin-settings__badge--warn {
  background: #fff4e5;
  color: #b15c00;
}

.admin-settings__hero {
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 14px;
  background: #f3efe4;
  cursor: pointer;
  border: 1px solid #ece6d8;
}

.admin-settings__hero img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.admin-settings__hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  background: linear-gradient(180deg, transparent 45%, rgba(14, 14, 14, 0.72) 100%);
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.admin-settings__hero:hover .admin-settings__hero-overlay,
.admin-settings__hero:focus-visible .admin-settings__hero-overlay {
  opacity: 1;
}

.admin-settings__hero-overlay span {
  font-size: 13px;
  font-weight: 600;
}

.admin-settings__hero-overlay em {
  font-style: normal;
  font-size: 12px;
  opacity: 0.85;
}

.admin-settings__card--hero {
  margin-top: 20px;
}

.admin-settings__hero-editor {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.2fr);
  gap: 0;
}

.admin-settings__hero-fields {
  padding: 20px 22px 22px;
  border-right: 1px solid #f1f1f1;
}

.admin-settings__hero-preview-wrap {
  padding: 20px 22px 22px;
  background: #faf8f3;
}

.admin-settings__preview-label {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8a8a8a;
}

.admin-settings__field {
  margin-bottom: 16px;
}

.admin-settings__text-input,
.admin-settings__textarea {
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  outline: none;
  padding: 11px 14px;
  font-size: 15px;
  background: #fff;
  color: #111;
}

.admin-settings__textarea {
  resize: vertical;
  min-height: 140px;
  line-height: 1.45;
}

.admin-settings__text-input:focus,
.admin-settings__textarea:focus {
  border-color: #c93312;
  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.12);
}

.admin-settings__color-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-settings__color-field input[type="color"] {
  width: 48px;
  height: 42px;
  padding: 4px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.admin-settings__cta-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: 12px;
}

.admin-settings__hint code {
  font-size: 11px;
  color: #444;
}

.admin-settings__actions-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.admin-settings__file-name {
  margin: 10px 0 0;
  color: #666;
  font-size: 12px;
}

.admin-settings__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding: 16px 18px;
  border: 1px solid #ececec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(17, 17, 17, 0.05);
}

.admin-settings__footer-copy {
  color: #666;
  font-size: 13px;
}

.admin-settings__footer-copy strong {
  color: #111;
}

.admin-settings__footer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 991.98px) {
  .admin-settings__grid,
  .admin-settings__hero-editor,
  .admin-settings__cta-grid {
    grid-template-columns: 1fr;
  }

  .admin-settings__hero-fields {
    border-right: 0;
    border-bottom: 1px solid #f1f1f1;
  }
}

@media (max-width: 575.98px) {
  .admin-settings {
    padding: 0 0 24px;
  }

  .admin-settings__title {
    font-size: 1.45rem;
  }

  .admin-settings__card-head,
  .admin-settings__card-body,
  .admin-settings__hero-fields,
  .admin-settings__hero-preview-wrap {
    padding-left: 16px;
    padding-right: 16px;
  }

  .admin-settings__footer {
    align-items: stretch;
  }

  .admin-settings__footer-actions {
    width: 100%;
  }

  .admin-settings__footer-actions .btn {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dashboard-admin/Settings.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,iFAAiF;EACjF,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,MAAM;AACR;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":[".admin-settings {\n  max-width: 1240px;\n  padding: 8px 8px 32px;\n}\n\n.admin-settings__header {\n  margin-bottom: 24px;\n}\n\n.admin-settings__eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #c93312;\n}\n\n.admin-settings__title {\n  margin: 0 0 8px;\n  color: #111 !important;\n  font-size: 1.75rem !important;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.admin-settings__subtitle {\n  margin: 0;\n  max-width: 640px;\n  color: #5b5b5b;\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.admin-settings__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.admin-settings__card {\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(17, 17, 17, 0.06);\n  overflow: hidden;\n}\n\n.admin-settings__card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid #f1f1f1;\n  background: linear-gradient(180deg, #fdf9ee 0%, #ffffff 100%);\n}\n\n.admin-settings__icon {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #fff;\n  color: #c93312;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.admin-settings__card-head h2 {\n  margin: 0 0 4px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #111;\n}\n\n.admin-settings__card-head p {\n  margin: 0;\n  color: #6b6b6b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.admin-settings__card-body {\n  padding: 20px 22px 22px;\n}\n\n.admin-settings__label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #222;\n}\n\n.admin-settings__price-field {\n  display: flex;\n  align-items: stretch;\n  overflow: hidden;\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.admin-settings__price-field:focus-within {\n  border-color: #c93312;\n  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.12);\n}\n\n.admin-settings__currency {\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  background: #f7f7f7;\n  color: #444;\n  font-weight: 700;\n  border-right: 1px solid #ececec;\n}\n\n.admin-settings__price-field input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  padding: 12px 14px;\n  font-size: 16px;\n  background: transparent;\n}\n\n.admin-settings__hint {\n  margin: 8px 0 0;\n  color: #7a7a7a;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.admin-settings__summary {\n  display: grid;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.admin-settings__stat {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n}\n\n.admin-settings__stat span {\n  color: #666;\n  font-size: 13px;\n}\n\n.admin-settings__stat strong {\n  color: #111;\n  font-size: 14px;\n}\n\n.admin-settings__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  background: #eef7ee;\n  color: #1f7a32;\n}\n\n.admin-settings__badge--muted {\n  background: #f3f3f3;\n  color: #555;\n}\n\n.admin-settings__badge--warn {\n  background: #fff4e5;\n  color: #b15c00;\n}\n\n.admin-settings__hero {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  border-radius: 14px;\n  background: #f3efe4;\n  cursor: pointer;\n  border: 1px solid #ece6d8;\n}\n\n.admin-settings__hero img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.admin-settings__hero-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px;\n  background: linear-gradient(180deg, transparent 45%, rgba(14, 14, 14, 0.72) 100%);\n  color: #fff;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.admin-settings__hero:hover .admin-settings__hero-overlay,\n.admin-settings__hero:focus-visible .admin-settings__hero-overlay {\n  opacity: 1;\n}\n\n.admin-settings__hero-overlay span {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.admin-settings__hero-overlay em {\n  font-style: normal;\n  font-size: 12px;\n  opacity: 0.85;\n}\n\n.admin-settings__card--hero {\n  margin-top: 20px;\n}\n\n.admin-settings__hero-editor {\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.2fr);\n  gap: 0;\n}\n\n.admin-settings__hero-fields {\n  padding: 20px 22px 22px;\n  border-right: 1px solid #f1f1f1;\n}\n\n.admin-settings__hero-preview-wrap {\n  padding: 20px 22px 22px;\n  background: #faf8f3;\n}\n\n.admin-settings__preview-label {\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8a8a8a;\n}\n\n.admin-settings__field {\n  margin-bottom: 16px;\n}\n\n.admin-settings__text-input,\n.admin-settings__textarea {\n  width: 100%;\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  outline: none;\n  padding: 11px 14px;\n  font-size: 15px;\n  background: #fff;\n  color: #111;\n}\n\n.admin-settings__textarea {\n  resize: vertical;\n  min-height: 140px;\n  line-height: 1.45;\n}\n\n.admin-settings__text-input:focus,\n.admin-settings__textarea:focus {\n  border-color: #c93312;\n  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.12);\n}\n\n.admin-settings__color-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-settings__color-field input[type=\"color\"] {\n  width: 48px;\n  height: 42px;\n  padding: 4px;\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.admin-settings__cta-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n  gap: 12px;\n}\n\n.admin-settings__hint code {\n  font-size: 11px;\n  color: #444;\n}\n\n.admin-settings__actions-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.admin-settings__file-name {\n  margin: 10px 0 0;\n  color: #666;\n  font-size: 12px;\n}\n\n.admin-settings__footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 20px;\n  padding: 16px 18px;\n  border: 1px solid #ececec;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(17, 17, 17, 0.05);\n}\n\n.admin-settings__footer-copy {\n  color: #666;\n  font-size: 13px;\n}\n\n.admin-settings__footer-copy strong {\n  color: #111;\n}\n\n.admin-settings__footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n@media (max-width: 991.98px) {\n  .admin-settings__grid,\n  .admin-settings__hero-editor,\n  .admin-settings__cta-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-settings__hero-fields {\n    border-right: 0;\n    border-bottom: 1px solid #f1f1f1;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .admin-settings {\n    padding: 0 0 24px;\n  }\n\n  .admin-settings__title {\n    font-size: 1.45rem;\n  }\n\n  .admin-settings__card-head,\n  .admin-settings__card-body,\n  .admin-settings__hero-fields,\n  .admin-settings__hero-preview-wrap {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .admin-settings__footer {\n    align-items: stretch;\n  }\n\n  .admin-settings__footer-actions {\n    width: 100%;\n  }\n\n  .admin-settings__footer-actions .btn {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
